<div class="out-of-office-container" *ngIf="!isLoadingData && !isLoadingLabels">
	<div>{{ labels.lbl_ausencia_temporaria }}</div>
	<cpi-generic-form-gen [setGenericForm]="outOfOfficeForm" [columns]="1" [labels]="labels" [periodDatePeriodOnly]="true">
	</cpi-generic-form-gen>

	<div class="float-card">
		{{ labels.lbl_substituto_responsavel }}
		<cpi-generic-form-gen [setGenericForm]="behalfOfForm" [labels]="labels"> </cpi-generic-form-gen>

		<div class="button-container">
			<div
				class="button"
				[ngClass]="{ disabled: isLoadingBehalfOf }"
				(click)="
					getAllowedBehalfOfUsers(
						dictionaryForm['name'].values[0],
						dictionaryForm['email'].values[0],
						dictionaryForm['customer'].values[0]
					)
				">
				<span>{{ labels.lbl_geral_pesquisar }}</span>
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isLoadingBehalfOf"> </cpi-dot-bounce-loading-effect>
			</div>
		</div>

		<cpi-input-with-autocomplete
			[availableOptions]="allowedBehalfOfUsersIAC"
			[placeholder]="labels.lbl_buscar_usuarios"
			[minInputLength]="0"
			[inputHeight]="'30px'"
			(onValueChange)="selectedBehalfOfUser.email = $event"
			[setInputText]="selectedBehalfOfUser.fullName !== undefined ? searchInputText : selectedBehalfOfUser.fullName"
			[setValue]="selectedBehalfOfUser.email ? selectedBehalfOfUser.email : ''"
			*ngIf="(!isLoadingBehalfOf && allowedBehalfOfUsersIAC.length > 0) || selectedBehalfOfUser.email">
		</cpi-input-with-autocomplete>
	</div>
</div>
